// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiDiagnosis {
    static getAttributeTypeMap() {
        return MedicalBiDiagnosis.attributeTypeMap;
    }
}
MedicalBiDiagnosis.discriminator = undefined;
MedicalBiDiagnosis.additionalProperties = false;
MedicalBiDiagnosis.attributeTypeMap = [
    {
        "name": "primaryIcdCode",
        "baseName": "primaryIcdCode",
        "type": "string"
    },
    {
        "name": "primaryIcdDescription",
        "baseName": "primaryIcdDescription",
        "type": "string"
    },
    {
        "name": "secondaryIcdCode",
        "baseName": "secondaryIcdCode",
        "type": "string"
    },
    {
        "name": "secondaryIcdDescription",
        "baseName": "secondaryIcdDescription",
        "type": "string"
    },
    {
        "name": "jCode",
        "baseName": "jCode",
        "type": "string"
    },
    {
        "name": "jCodeUnit",
        "baseName": "jCodeUnit",
        "type": "string"
    },
    {
        "name": "cptCode",
        "baseName": "cptCode",
        "type": "string"
    },
    {
        "name": "cptCodeUnit",
        "baseName": "cptCodeUnit",
        "type": "string"
    },
    {
        "name": "treatmentDate",
        "baseName": "treatmentDate",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiDiagnosis.js.map